import { Routes } from '@angular/router';
import { LoginComponent } from './component/login/login.component';
import { PasswordResetComponent } from './component/password-reset/password-reset.component';
import { PasswordChangeComponent } from './component/password-change/password-change.component';
import { SingleSignOnComponent } from './component/single-sign-on/single-sign-on.component';
import { LoggedOutComponent } from './component/logged-out/logged-out.component';

export const SessionRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'password-reset',
    component: PasswordResetComponent,
  },
  {
    path: 'password-change',
    component: PasswordChangeComponent,
  },
  {
    path: 'sso',
    component: SingleSignOnComponent,
  },
  {
    path: 'logged-out',
    component: LoggedOutComponent,
  },
];
